import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  listSubHeader: {
    fontWeight: 700,
    color: '#242424',
  },
}));
